import React, { useState } from "react";
import clsx from "clsx";
import { Button, Paper, Fade, Slide } from "@material-ui/core";
import { withCookies } from "react-cookie";
import config from "cfg/config";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { compose } from "utils/WebUtils";
import { withRouter } from "react-router-dom";

// Material components
import { yellow } from "@material-ui/core/colors";

const drawerWidth = 280;

import {
    Box,
    Avatar,
    Toolbar,
    Typography,
    Drawer,
    AppBar,
    IconButton,
    Tooltip,
    CircularProgress
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
    ExpandMore as ArrowDown,
    ExpandLess as ArrowUp,
    Warning as WarningIcon,
    ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon,
    Help as HelpIcon,
    MoreHorizTwoTone as MoreIcon
} from "@material-ui/icons";
import {} from "@material-ui/core/";
import { loadingOrg } from "redux/selectors/user.selector";

// Portal components
import OrganizationSidenav from "../../components/notification-sidenav/organization-sidenav.component";

import logoImage from "assets/images/chargebee-icon-orange.png";

// Actions
import {
    toggleSidenav,
    toggleOrganizations
} from "redux/actions/layout.actions";

import { AccountingUtils } from "revlock-accounting";
import UserMenu from "components/user/UserMenu";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";

function HelpMenu(props) {
    // const [sidebar, setSide] = React.useState(false);

    const { classes, layout } = props;

    const showHelp = () => {
        window.open("https://www.chargebee.com/docs/revrec/quick-start.html", "_blank");
    };

    return (
        <List id="help" component="nav" disablePadding>
            <Tooltip
                title={layout.sidenavOpen ? "" : "Need Help"}
                placement="right"
            >
                <ListItem
                    onClick={showHelp}
                    button
                    className={classes.listItemText}
                    classes={{
                        root: classes.bottomListItemRootOverrides,
                        gutters: classes.listItemGuttersOverrides
                    }}
                >
                    <ListItemIcon
                        classes={{ root: classes.bottomListItemIconOverrides }}
                    >
                        <HelpIcon className={classes.listIcon} />
                    </ListItemIcon>
                    <ListItemText disableTypography>Need Help</ListItemText>
                    <ListItemIcon
                        classes={{ root: classes.listItemIconOverrides }}
                    >
                        <MoreIcon className={classes.listIcon} />
                    </ListItemIcon>
                </ListItem>
            </Tooltip>
        </List>
    );
}

const Sidenav = props => {
    const { layout, classes, cookies, ...rest } = props;
    const [orgNav, setOrgNav] = useState(false);

    const renderEnvironments = () => {
        const { classes, currentOrganization } = props;
        if (!currentOrganization) return null;

        const isTest = AccountingUtils.isTestId(currentOrganization.id);
        const isConsolidateOrg = AccountingUtils.isConsolidatedId(currentOrganization.id)
        const isConsolidateTestOrg = AccountingUtils.isConsolidatedTestId(currentOrganization.id)

        const label = currentOrganization.name; //+ (isProd ? ' - Production' : ' - Test')

        return (
            <TenantSelectorDropDown
                id={"environments"}
                classes={classes}
                title={label}
                subTitle={isTest ? "Test" : isConsolidateOrg ? "Consolidated" : isConsolidateTestOrg ? "Consolidated Test" : "Production"}
                clickable={true}
                isPrimary={!isTest}
                style={{ paddingLeft: "29px" }}
                orgNav={setOrgNav}
                props={props}
            />
        );
    };
    const open = layout.sidenavOpen;

    const currentServiceProfile =
        window.location.hostname === "localhost"
            ? cookies.get("simulatedLocalRedirectProfile") ||
            config.serviceProfile
            : config.serviceProfile;

    return (
        <Drawer
            classes={{
                paper: clsx(classes.drawerOverride, {
                    [classes.sideNavOpen]: open,
                    [classes.sideNavDocked]: !open
                })
            }}
            className={clsx(classes.sideNav, {
                [classes.sideNavOpen]: open,
                [classes.sideNavDocked]: !open
            })}
            variant="permanent"
            open={layout.sidenavOpen}
            onClose={props.toggleSidenav}
        >
            {/* top button to change environments */}
            {open && (
                <Toolbar
                    color="inherit"
                    position="static"
                    classes={{ gutters: orgNav ? classes.toolBarGutterOverridesOpen : classes.toolBarGutterOverrides }}
                >
                    {renderEnvironments()}
                </Toolbar>
            )}

            {/* main menu */}
            {orgNav ? (
                <Fade in={orgNav} unmountOnExit={true}>
                    <div className={classes.orgSidebar}>
                        <OrganizationSidenav className='oddEvenList' {...rest} />
                    </div>
                </Fade>
            ) : props.children}
            {/* sidenav footer */}
            <Slide direction="up" in={!orgNav} unmountOnExit={true}>
                <AppBar color="default" position="static" className={classes.sideNavFooter}>
                    <Toolbar disableGutters>
                        <Box
                            display={"flex"}
                            flexDirection={"column"}
                            flex={1}
                            justifyContent={"flex-start"}
                            paddingTop={1}
                        >
                            <Box style={{ padding: open ? "0 8px" : 0 }}>
                                <HelpMenu classes={classes} layout={layout} />
                                <UserMenu classes={classes} layout={layout} />
                            </Box>
                            <Divider mt={1} className={classes.divider} />
                            <Box
                                width={open ? "auto" : "100%"}
                                justifyContent={open ? "space-between" : "center"}
                                display={"flex"}
                                paddingLeft={open ? 2.5 : 0}
                                paddingRight={1}
                                alignItems={"center"}
                            >
                                {open && (
                                    <Typography
                                        variant="caption"
                                        color="inherit"
                                        noWrap
                                    >
                                        <small>
                                            &copy; 2023 REVREC{" "}
                                            {currentServiceProfile
                                                ? `(${currentServiceProfile})`
                                                : ""}
                                        </small>
                                    </Typography>
                                )}
                                <IconButton onClick={props.toggleSidenav}>
                                    {open ? (
                                        <ChevronLeftIcon />
                                    ) : (
                                        <ChevronRightIcon />
                                    )}
                                </IconButton>
                            </Box>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Slide>
        </Drawer>
    );
};

function TenantSelectorDropDown(props) {
    const {
        id,
        width,
        classes,
        title,
        hasError,
        isLoading,
        subTitle,
        clickable,
        isResponsive,
        isButton,
        orgNav
    } = props;

    const { ...rest } = props.props;
    const isSmallScreen = width === "sm" || width === "xs";
    const showAvatarOnly = isSmallScreen && isResponsive;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(open ? null : event.currentTarget);
        orgNav(!open);
    };

    const handleClose = () => {
        setAnchorEl(null);
        orgNav(false);
    };

    return (
        <div
            className={classes.dropDownMenuPrimary}
            onClick={props.onClick && !isLoading ? props.onClick : () => { }}
        >
            <div>
                {hasError && (
                    <WarningIcon
                        className={classes.dpIcon}
                        style={{
                            color: yellow[800],
                            width: "25px"
                        }}
                    />
                )}

                {/* Organisation Button */}
                <Button
                    id={id}
                    variant="contained"
                    classes={{
                        root: open
                            ? classes.buttonOpenRootOverrides
                            : classes.buttonClosedRootOverrides
                    }}
                    onClick={handleClick}
                >
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                    >
                       
                            <img className={classes.logo} src={logoImage} onclick={() => {window.location='https://app.chargebee.com/login'}} />
                        <div
                            className={classes.dpTextContainer}
                            style={{ textAlign: "left" }}
                        >
                            <Tooltip title={title}>
                                <Typography
                                    variant="body2"
                                    className={`${classes.orgTitle} ${classes.orgTitleSidenav}`}
                                    align="left"
                                >
                                    {title || "N/A"}
                                </Typography>
                            </Tooltip>
                            {subTitle && (
                                <Tooltip title={subTitle}>
                                    <Typography
                                        variant="body2"
                                        className={`${classes.dpSubtitle} ${classes.orgTitleSidenav}`}
                                        align="left"
                                    >
                                        {subTitle}
                                    </Typography>
                                </Tooltip>
                            )}
                        </div>
                    </Box>
                    <div>
                        {isLoading && (
                            <CircularProgress size={20} color={"primary"} />
                        )}
                        {clickable &&
                            !isLoading &&
                            !showAvatarOnly &&
                            !isButton && (
                                <Box display={'flex'} alignItems={'center'}>
                                    <ArrowDown
                                        style={{
                                            color: "#a8a9ac",
                                            transform: `scaleY(${open ? -1 : 1})`
                                        }}
                                    />
                                </Box>
                            )}
                    </div>
                </Button>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        theme: state.theme,
        layout: {
            sidenavOpen: state.layout.sidenavOpen
        },
        loadingOrg: loadingOrg(state)
    };
}

Sidenav.propTypes = {
    toggleSidenav: PropTypes.func.isRequired,
    children: PropTypes.shape({}).isRequired
};

const styles = theme => ({
    buttonClosedRootOverrides: {
        backgroundColor: theme.palette.background.button.main,
        justifyContent: "space-between",
        padding: 12,
        borderRadius: 8,
        color: "white",
        width: "100%",
        "&:hover": {
            background: theme.palette.background.button.main
        }
    },
    buttonOpenRootOverrides: {
        backgroundColor: theme.palette.background.button.main,
        justifyContent: "space-between",
        padding: 12,
        borderRadius: 0,
        color: "white",
        width: "100%",
        "&:hover": {
            background: theme.palette.background.button.main
        }

    },
    topMenu: {


    },
    orgSidebar: {
        backgroundColor: "white",
        overflow: 'auto',
        height: '100%',

        "& .MuiListItem-container": {
            "&:nth-child(even)": {
                background: "#f8f8f8"
            },
            "&:hover": {
                background: "#eeeeee"
            }
        }
    },
    divider: {
        marginTop: 8
    },
    toolBarGutterOverrides: {
        paddingTop: theme.spacing(1.2),
        paddingBottom: theme.spacing(1.2),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        transition: theme.transitions.create("padding", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
    },
    toolBarGutterOverridesOpen: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: -1,
        transition: theme.transitions.create("padding", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
    },
    drawerOverride: {
        borderTopRightRadius: theme.spacing(1),
        borderBottomRightRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.default
    },
    sideNav: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap"
    },
    sideNavOpen: {
        width: 260,
        overflow: 'hidden',
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        borderTopRightRadius: theme.spacing(0),
        borderTopLeftRadius: theme.spacing(0),
        boxShadow: `1px 0 2px 0 rgb(234 234 234 / 8%), 6px 0 10px 0 rgb(234 234 234 / 8%)`
    },
    sideNavDocked: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7.2) + 1
        },
        color: "#fff",
        overflow: "hidden",
        "& header": {
            backgroundColor: theme.palette.primary.main,
            "& .MuiPaper-root": {
                "& .MuiToolbar-root": {
                    "& .MuiListItem-button": {
                        paddingLeft: "9px",
                        width: "5px!important",
                        "& .MuiListItemIcon-root": {
                            background: "transparent",
                            minWidth: "24px",
                            padding: "8px",
                            marginRight: "15px",
                            borderRadius: "5px",
                            "&:hover": {
                                backgroundColor: theme.palette.primary[300]
                            }
                        }
                    },
                    "& .MuiIconButton-root": {
                        "& svg": {
                            fill: "#fff"
                        },
                        "&:hover": {
                            color:theme.palette.background.neutral[200]
                            // backgroundColor: `${theme.palette.primary[300]} !important`
                        }
                    },
                    "& .MuiToolbar-root": {
                        "& .MuiBox-root": {
                            width: "58px",
                            background: theme.palette.primary.main
                        }
                    },
                    background: theme.palette.primary.main,
                    overflow: "hidden"
                }
            }
        },
        "& .MuiSvgIcon-root": {
            fill: "#eaeaf4",
            opacity: 0.6
        },

        "& .MuiListItemIcon-root": {
            marginRight: "40px"
        },

        "& .setMenuActive": {
            fontWeight: 600,
            color: theme.palette.primary.main,
            backgroundColor: "rgb(234, 234, 244)",
            "& .MuiSvgIcon-root": {
                fill: theme.palette.background.neutral[600]
            }
        },
        "& .MuiListItem-button": {
            "&:hover": {
                background: theme.palette.primary[300],
                borderRadius: "5px",
                "& .MuiSvgIcon-root": {
                    fill: "#ffffff",
                    opacity: 1
                },
                "& .MuiTypography-body1": {
                    color: "#ffffff"
                }
            }
            // backgroundColor: '#782ca8',
            // borderRadius: '5px'
        },
        "& #menu": {
            "&>div:first-child": {
                overflowX: "hidden"
            }
        },
        "& .MuiBox-root": {
            overflowX: "hidden",
            "& #my-account": {
                paddingLeft: 13,
                paddingRight: 10,
                width: "50px !important",
                marginLeft: 4
            },
            "& #help": {
                paddingLeft: "3px",
                paddingRight: "6px",
                "& .MuiButtonBase-root": {
                    paddingLeft: "13px"
                }
            }
        }
    },
    dropDownMenuPrimary: {
        width: "100%",
        cursor: "pointer",
        "&:hover": {}
    },
    dpIcon: {
        width: "1em !important",
        height: "1em !important"
    },
    dpTextContainer: {
        display: "flex",
        flexDirection: "column"
    },
    logo: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        height: '24px'
    },
    orgTitleSidenav: {
        whiteSpace: "nowrap",
        overflow: "hidden !important",
        textOverflow: "ellipsis",
        textTransform: "none",
        width: "145px",
        paddingRight: 16,
        fontWeight: 600
    },
    orgTitle: {
        color: "inherit",
        fontSize: 14,
        fontWeight: 500
    },
    dpSubtitle: {
        color: theme.palette.background.info[200],
        fontSize: 12,
        textTransform: "capitalize"
    },
    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3)
    },
    impersonation: {
        display: "flex"
    },
    listItemText: {
        flex: "1 1 100%",
        textTransform: "none",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.75,
        color: theme.palette.background.neutral[600] ,
        "&hover": {
            color: theme.palette.background.neutral[600],
            fontWeight: 600
        }
    },
    listIcon: {
        height: "24px",
        color: theme.palette.background.neutral[600],
        "&hover": {
            color: theme.palette.background.neutral[600]
        }
    },
    listItemIconOverrides: {
        color: theme.palette.background.neutral[600],
        minWidth: theme.spacing(4),
        height: theme.spacing(3)
    },
    bottomListItemIconOverrides: {
        justifyContent: "center",
        color: theme.palette.background.neutral[600],
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(2)
    },
    listItemGuttersOverrides: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    listItemRootOverrides: {
        padding: 0,
        borderRadius: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        marginLeft: theme.spacing(1),
        paddingTop: 3,
        paddingBottom: 3
    },
    bottomListItemRootOverrides: {
        borderRadius: theme.spacing(1),
        padding: "3px 8px"
    },
    popover: {
        marginLeft: theme.spacing(-1)
    }
});

export default compose(
    withRouter,
    withCookies,
    connect(mapStateToProps, {
        toggleSidenav,
        toggleOrganizations
    }),
    withStyles(styles, { withTheme: true })
)(Sidenav);
